module.exports = __webpack_public_path__ + "img/ybAccount.da186cf6.png";